/**
 * Generated. DO NOT edit directly
 */

export const color_global_brand_raw_carbon = '#191919';
export const color_global_brand_raw_slate = '#6B665F';
export const color_global_brand_raw_gravel = '#AFABA1';
export const color_global_brand_raw_sand = '#E8DCC7';
export const color_global_brand_raw_cream = '#F6F1E7';
export const color_global_brand_raw_snow = '#FEFEFA';
export const color_global_brand_raw_cobalt = '#1A31A9';
export const color_global_brand_raw_sky = '#3F59E4';
export const color_global_brand_raw_cloud = '#B6C9FF';
export const color_global_brand_raw_ocean = '#096256';
export const color_global_brand_raw_seafoam = '#4CB7A3';
export const color_global_brand_raw_turquoise = '#B1E4DE';
export const color_global_brand_raw_eggplant = '#4016A0';
export const color_global_brand_raw_violet = '#7549F2';
export const color_global_brand_raw_lilac = '#B49BFC';
export const color_global_brand_raw_forest = '#0F5C34';
export const color_global_brand_raw_emerald = '#149750';
export const color_global_brand_raw_pistachio = '#8FC88A';
export const color_global_brand_raw_clay = '#763101';
export const color_global_brand_raw_tangerine = '#E27133';
export const color_global_brand_raw_melon = '#F2AC84';
export const color_global_brand_raw_walnut = '#744E00';
export const color_global_brand_raw_goldenrod = '#EF9B05';
export const color_global_brand_raw_wheat = '#F4D594';
export const color_global_functional_static_neutral_50 = '#96989D';
export const color_global_functional_static_neutral_100 = '#65676E';
export const color_global_functional_static_neutral_200 = '#41444B';
export const color_global_functional_static_neutral_300 = '#1E212A';
export const color_global_functional_static_neutral_white = '#FFFFFF';
export const color_global_functional_static_neutral_black = '#000000';
export const color_global_functional_static_magenta_50 = '#FF44DD';
export const color_global_functional_static_magenta_100 = '#C638A7';
export const color_global_functional_static_magenta_200 = '#8D2B72';
export const color_global_functional_static_magenta_300 = '#541F3C';
export const color_global_functional_static_blue_50 = '#1071F2';
export const color_global_functional_static_blue_100 = '#0B61CB';
export const color_global_functional_static_blue_200 = '#0550A4';
export const color_global_functional_static_blue_300 = '#00407D';
export const color_global_functional_static_red_50 = '#D03C38';
export const color_global_functional_static_red_100 = '#AA2D31';
export const color_global_functional_static_red_200 = '#841E2A';
export const color_global_functional_static_red_300 = '#5F0F24';
export const color_global_functional_static_green_50 = '#13A688';
export const color_global_functional_static_green_100 = '#0D8975';
export const color_global_functional_static_green_200 = '#066B61';
export const color_global_functional_static_green_300 = '#004E4E';
export const color_global_functional_static_yellow_50 = '#EBCA40';
export const color_global_functional_static_yellow_100 = '#B8952E';
export const color_global_functional_static_yellow_200 = '#85611B';
export const color_global_functional_static_yellow_300 = '#522C09';
export const color_global_functional_static_purple_50 = '#635DFF';
export const color_global_functional_static_purple_100 = '#564ED1';
export const color_global_functional_static_purple_200 = '#493FA3';
export const color_global_functional_static_purple_300 = '#3C3075';
export const color_global_functional_dark_neutral_50 = '#1E212A';
export const color_global_functional_dark_neutral_100 = '#1E212A';
export const color_global_functional_dark_neutral_200 = '#1E212A';
export const color_global_functional_dark_neutral_300 = '#41444B';
export const color_global_functional_dark_neutral_400 = '#65676E';
export const color_global_functional_dark_neutral_500 = '#96989D';
export const color_global_functional_dark_neutral_600 = '#C9CACE';
export const color_global_functional_dark_neutral_700 = '#E3E4E6';
export const color_global_functional_dark_neutral_800 = '#EFF0F2';
export const color_global_functional_dark_neutral_900 = '#EFF0F2';
export const color_global_functional_dark_neutral_1000 = '#EFF0F2';
export const color_global_functional_dark_magenta_50 = '#541F3C';
export const color_global_functional_dark_magenta_100 = '#541F3C';
export const color_global_functional_dark_magenta_200 = '#541F3C';
export const color_global_functional_dark_magenta_300 = '#8D2B72';
export const color_global_functional_dark_magenta_400 = '#C638A7';
export const color_global_functional_dark_magenta_500 = '#FF44DD';
export const color_global_functional_dark_magenta_600 = '#FF79E7';
export const color_global_functional_dark_magenta_700 = '#FFAFF0';
export const color_global_functional_dark_magenta_800 = '#FFE4FA';
export const color_global_functional_dark_magenta_900 = '#FFE4FA';
export const color_global_functional_dark_magenta_1000 = '#FFE4FA';
export const color_global_functional_dark_blue_50 = '#00407D';
export const color_global_functional_dark_blue_100 = '#00407D';
export const color_global_functional_dark_blue_200 = '#00407D';
export const color_global_functional_dark_blue_300 = '#0550A4';
export const color_global_functional_dark_blue_400 = '#0B61CB';
export const color_global_functional_dark_blue_500 = '#1071F2';
export const color_global_functional_dark_blue_600 = '#549AF6';
export const color_global_functional_dark_blue_700 = '#99C2F9';
export const color_global_functional_dark_blue_800 = '#DDEBFD';
export const color_global_functional_dark_blue_900 = '#DDEBFD';
export const color_global_functional_dark_blue_1000 = '#DDEBFD';
export const color_global_functional_dark_green_50 = '#004E4E';
export const color_global_functional_dark_green_100 = '#004E4E';
export const color_global_functional_dark_green_200 = '#004E4E';
export const color_global_functional_dark_green_300 = '#066B61';
export const color_global_functional_dark_green_400 = '#0D8975';
export const color_global_functional_dark_green_500 = '#13A688';
export const color_global_functional_dark_green_600 = '#31CEA8';
export const color_global_functional_dark_green_700 = '#88E3CD';
export const color_global_functional_dark_green_800 = '#DEF7F1';
export const color_global_functional_dark_green_900 = '#DEF7F1';
export const color_global_functional_dark_green_1000 = '#DEF7F1';
export const color_global_functional_dark_red_50 = '#5F0F24';
export const color_global_functional_dark_red_100 = '#5F0F24';
export const color_global_functional_dark_red_200 = '#5F0F24';
export const color_global_functional_dark_red_300 = '#841E2A';
export const color_global_functional_dark_red_400 = '#AA2D31';
export const color_global_functional_dark_red_500 = '#D03C38';
export const color_global_functional_dark_red_600 = '#FF685B';
export const color_global_functional_dark_red_700 = '#FFABA4';
export const color_global_functional_dark_red_800 = '#FFEEED';
export const color_global_functional_dark_red_900 = '#FFEEED';
export const color_global_functional_dark_red_1000 = '#FFEEED';
export const color_global_functional_dark_yellow_50 = '#522C09';
export const color_global_functional_dark_yellow_100 = '#522C09';
export const color_global_functional_dark_yellow_200 = '#522C09';
export const color_global_functional_dark_yellow_300 = '#85611B';
export const color_global_functional_dark_yellow_400 = '#B8952E';
export const color_global_functional_dark_yellow_500 = '#EBCA40';
export const color_global_functional_dark_yellow_600 = '#F1D977';
export const color_global_functional_dark_yellow_700 = '#F6E8AD';
export const color_global_functional_dark_yellow_800 = '#FCF7E4';
export const color_global_functional_dark_yellow_900 = '#FCF7E4';
export const color_global_functional_dark_yellow_1000 = '#FCF7E4';
export const color_global_functional_dark_purple_50 = '#3C3075';
export const color_global_functional_dark_purple_100 = '#3C3075';
export const color_global_functional_dark_purple_200 = '#3C3075';
export const color_global_functional_dark_purple_300 = '#493FA3';
export const color_global_functional_dark_purple_400 = '#564ED1';
export const color_global_functional_dark_purple_500 = '#635DFF';
export const color_global_functional_dark_purple_600 = '#908BFF';
export const color_global_functional_dark_purple_700 = '#BCBAFF';
export const color_global_functional_dark_purple_800 = '#E9E8FF';
export const color_global_functional_dark_purple_900 = '#E9E8FF';
export const color_global_functional_dark_purple_1000 = '#E9E8FF';
export const color_global_functional_dark_teal_50 = '#0C1C19';
export const color_global_functional_dark_teal_100 = '#1C443D';
export const color_global_functional_dark_teal_200 = '#275E53';
export const color_global_functional_dark_teal_300 = '#307366';
export const color_global_functional_dark_teal_400 = '#419D8C';
export const color_global_functional_dark_teal_500 = '#75C7B8';
export const color_global_functional_dark_teal_600 = '#B3E0D8';
export const color_global_functional_dark_teal_700 = '#D4EEE9';
export const color_global_functional_dark_teal_800 = '#E4F4F1';
export const color_global_functional_dark_teal_900 = '#EFF8F7';
export const color_global_functional_dark_teal_1000 = '#F7FCFB';
export const color_global_functional_dark_orange_50 = '#291409';
export const color_global_functional_dark_orange_100 = '#613016';
export const color_global_functional_dark_orange_200 = '#85421E';
export const color_global_functional_dark_orange_300 = '#A35125';
export const color_global_functional_dark_orange_400 = '#DE6F32';
export const color_global_functional_dark_orange_500 = '#EEA984';
export const color_global_functional_dark_orange_600 = '#F5D0BB';
export const color_global_functional_dark_orange_700 = '#F9E4D8';
export const color_global_functional_dark_orange_800 = '#FCEEE7';
export const color_global_functional_dark_orange_900 = '#FDF5F1';
export const color_global_functional_dark_orange_1000 = '#FEFAF8';
export const color_global_functional_dark_gold_50 = '#241701';
export const color_global_functional_dark_gold_100 = '#563802';
export const color_global_functional_dark_gold_200 = '#754C02';
export const color_global_functional_dark_gold_300 = '#905D03';
export const color_global_functional_dark_gold_400 = '#C47F04';
export const color_global_functional_dark_gold_500 = '#F2AB2E';
export const color_global_functional_dark_gold_600 = '#F8D28F';
export const color_global_functional_dark_gold_700 = '#FBE6C0';
export const color_global_functional_dark_gold_800 = '#FCEFD8';
export const color_global_functional_dark_gold_900 = '#FDF6E7';
export const color_global_functional_dark_gold_1000 = '#FEFAF3';
export const color_global_functional_light_neutral_50 = '#EFF0F2';
export const color_global_functional_light_neutral_100 = '#EFF0F2';
export const color_global_functional_light_neutral_200 = '#EFF0F2';
export const color_global_functional_light_neutral_300 = '#E3E4E6';
export const color_global_functional_light_neutral_400 = '#C9CACE';
export const color_global_functional_light_neutral_500 = '#96989D';
export const color_global_functional_light_neutral_600 = '#65676E';
export const color_global_functional_light_neutral_700 = '#41444B';
export const color_global_functional_light_neutral_800 = '#1E212A';
export const color_global_functional_light_neutral_900 = '#1E212A';
export const color_global_functional_light_neutral_1000 = '#1E212A';
export const color_global_functional_light_magenta_50 = '#FFE4FA';
export const color_global_functional_light_magenta_100 = '#FFE4FA';
export const color_global_functional_light_magenta_200 = '#FFE4FA';
export const color_global_functional_light_magenta_300 = '#FFAFF0';
export const color_global_functional_light_magenta_400 = '#FF79E7';
export const color_global_functional_light_magenta_500 = '#FF44DD';
export const color_global_functional_light_magenta_600 = '#C638A7';
export const color_global_functional_light_magenta_700 = '#8D2B72';
export const color_global_functional_light_magenta_800 = '#541F3C';
export const color_global_functional_light_magenta_900 = '#541F3C';
export const color_global_functional_light_magenta_1000 = '#541F3C';
export const color_global_functional_light_blue_50 = '#DDEBFD';
export const color_global_functional_light_blue_100 = '#DDEBFD';
export const color_global_functional_light_blue_200 = '#DDEBFD';
export const color_global_functional_light_blue_300 = '#99C2F9';
export const color_global_functional_light_blue_400 = '#549AF6';
export const color_global_functional_light_blue_500 = '#1071F2';
export const color_global_functional_light_blue_600 = '#0B61CB';
export const color_global_functional_light_blue_700 = '#0550A4';
export const color_global_functional_light_blue_800 = '#00407D';
export const color_global_functional_light_blue_900 = '#00407D';
export const color_global_functional_light_blue_1000 = '#00407D';
export const color_global_functional_light_green_50 = '#DEF7F1';
export const color_global_functional_light_green_100 = '#DEF7F1';
export const color_global_functional_light_green_200 = '#DEF7F1';
export const color_global_functional_light_green_300 = '#88E3CD';
export const color_global_functional_light_green_400 = '#31CEA8';
export const color_global_functional_light_green_500 = '#13A688';
export const color_global_functional_light_green_600 = '#0D8975';
export const color_global_functional_light_green_700 = '#066B61';
export const color_global_functional_light_green_800 = '#004E4E';
export const color_global_functional_light_green_900 = '#004E4E';
export const color_global_functional_light_green_1000 = '#004E4E';
export const color_global_functional_light_red_50 = '#FFEEED';
export const color_global_functional_light_red_100 = '#FFEEED';
export const color_global_functional_light_red_200 = '#FFEEED';
export const color_global_functional_light_red_300 = '#FFABA4';
export const color_global_functional_light_red_400 = '#FF685B';
export const color_global_functional_light_red_500 = '#D03C38';
export const color_global_functional_light_red_600 = '#AA2D31';
export const color_global_functional_light_red_700 = '#841E2A';
export const color_global_functional_light_red_800 = '#5F0F24';
export const color_global_functional_light_red_900 = '#5F0F24';
export const color_global_functional_light_red_1000 = '#5F0F24';
export const color_global_functional_light_yellow_50 = '#FCF7E4';
export const color_global_functional_light_yellow_100 = '#FCF7E4';
export const color_global_functional_light_yellow_200 = '#FCF7E4';
export const color_global_functional_light_yellow_300 = '#F6E8AD';
export const color_global_functional_light_yellow_400 = '#F1D977';
export const color_global_functional_light_yellow_500 = '#EBCA40';
export const color_global_functional_light_yellow_600 = '#B8952E';
export const color_global_functional_light_yellow_700 = '#85611B';
export const color_global_functional_light_yellow_800 = '#522C09';
export const color_global_functional_light_yellow_900 = '#522C09';
export const color_global_functional_light_yellow_1000 = '#522C09';
export const color_global_functional_light_purple_50 = '#E9E8FF';
export const color_global_functional_light_purple_100 = '#E9E8FF';
export const color_global_functional_light_purple_200 = '#E9E8FF';
export const color_global_functional_light_purple_300 = '#BCBAFF';
export const color_global_functional_light_purple_400 = '#908BFF';
export const color_global_functional_light_purple_500 = '#635DFF';
export const color_global_functional_light_purple_600 = '#564ED1';
export const color_global_functional_light_purple_700 = '#493FA3';
export const color_global_functional_light_purple_800 = '#3C3075';
export const color_global_functional_light_purple_900 = '#3C3075';
export const color_global_functional_light_purple_1000 = '#3C3075';
export const color_global_functional_light_teal_50 = '#F7FCFB';
export const color_global_functional_light_teal_100 = '#EFF8F7';
export const color_global_functional_light_teal_200 = '#E4F4F1';
export const color_global_functional_light_teal_300 = '#D4EEE9';
export const color_global_functional_light_teal_400 = '#B3E0D8';
export const color_global_functional_light_teal_500 = '#75C7B8';
export const color_global_functional_light_teal_600 = '#419D8C';
export const color_global_functional_light_teal_700 = '#307366';
export const color_global_functional_light_teal_800 = '#275E53';
export const color_global_functional_light_teal_900 = '#1C443D';
export const color_global_functional_light_teal_1000 = '#0C1C19';
export const color_global_functional_light_orange_50 = '#FEFAF8';
export const color_global_functional_light_orange_100 = '#FDF5F1';
export const color_global_functional_light_orange_200 = '#FCEEE7';
export const color_global_functional_light_orange_300 = '#F9E4D8';
export const color_global_functional_light_orange_400 = '#F5D0BB';
export const color_global_functional_light_orange_500 = '#EEA984';
export const color_global_functional_light_orange_600 = '#DE6F32';
export const color_global_functional_light_orange_700 = '#A35125';
export const color_global_functional_light_orange_800 = '#85421E';
export const color_global_functional_light_orange_900 = '#613016';
export const color_global_functional_light_orange_1000 = '#291409';
export const color_global_functional_light_gold_50 = '#FEFAF3';
export const color_global_functional_light_gold_100 = '#FDF6E7';
export const color_global_functional_light_gold_200 = '#FCEFD8';
export const color_global_functional_light_gold_300 = '#FBE6C0';
export const color_global_functional_light_gold_400 = '#F8D28F';
export const color_global_functional_light_gold_500 = '#F2AB2E';
export const color_global_functional_light_gold_600 = '#C47F04';
export const color_global_functional_light_gold_700 = '#905D03';
export const color_global_functional_light_gold_800 = '#754C02';
export const color_global_functional_light_gold_900 = '#563802';
export const color_global_functional_light_gold_1000 = '#241701';
export const color_border_default = '#E3E4E6'; // Use for dividers and page-level UI elements such as sidebars and page headers. ⚠️ Not an accessible border — do not use for inputs.
export const color_border_bold = '#C9CACE'; // Use for UI components that require a more-prominent border. ⚠️ Not an accessible border — do not use for inputs.
export const color_border_inverse_static = '#65676E'; // Use on high-contrast backgrounds that share the same color value across all themes.
export const color_border_focus = '#BCBAFF'; // Default focus color for all interactive elements.
export const color_border_focus_bold = '#635DFF'; // A more prominent version of Focus.
export const color_border_focus_state_danger = '#D03C38'; // A danger version of Focus.
export const color_border_selected = '#635DFF'; // Use for selected UI components.
export const color_border_disabled = '#C9CACE'; // Use for disabled UI components.
export const color_border_disabled_selected = '#96989D'; // Use for selected UI components that are disabled.
export const color_border_button = '#C9CACE'; // Border color for the default Button.
export const color_border_input = '#C9CACE'; // Accessible border color for inputs.
export const color_border_input_hover = '#65676E'; // Hover state for Input.
export const color_border_input_disabled = '#C9CACE'; // Disabled border color for inputs.
export const color_border_state_neutral = '#96989D'; // Use for neutral states.
export const color_border_state_info = '#1071F2'; // Use for info states.
export const color_border_state_success = '#13A688'; // Use for success states.
export const color_border_state_caution = '#EBCA40'; // Use for caution or warning states.
export const color_border_state_danger = '#D03C38'; // Use for danger or error states.
export const color_border_brand_primary = '#635DFF'; // Use to highlight branded elements on a page or for labels.
export const color_border_brand_primary_subtle = '#BCBAFF'; // A less prominent version of Brand Primary.
export const color_border_focus_inverse_static = 'rgba(255, 255, 255, 0.4)'; // Default focus color for all Inverse Static elements that sit on high contrast backgrounds or images.
export const color_bg_page = '#FFFFFF'; // Default color for page background.
export const color_bg_layer = '#FFFFFF'; // Default color for the majority of UI components.
export const color_bg_layer_bold = '#C9CACE'; // A more prominent version of Layer.
export const color_bg_layer_boldest = '#000000'; // The most prominent version of Layer and is typically used for tooltips or contrasting backgrounds.
export const color_bg_layer_alternate = '#EFF0F2'; // An alternate color of Layer and is typically used to establish contrast between UI elements.
export const color_bg_layer_alternate_bold = '#E3E4E6'; // A more prominent version of Layer Alternate.
export const color_bg_layer_elevated = '#FFFFFF'; // Default color for elevated UI layers such as modals or dialogs.
export const color_bg_backdrop = 'rgba(30, 33, 42, 0.75)'; // Default color for the layer that goes behind dialogs to narrow the user’s focus.
export const color_bg_interactive = '#FFFFFF'; // User for interactive layers or components on a page.
export const color_bg_interactive_hover = '#EFF0F2'; // Hover state for Interactive.
export const color_bg_interactive_pressed = '#E3E4E6'; // Pressed state for Interactive.
export const color_bg_disabled = '#E3E4E6'; // Use for disabled backgrounds.
export const color_bg_disabled_subtle = '#65676E'; // A less prominent version of Disabled and is typically used on top of Disabled for some UI controls, such as a Switch knob.
export const color_bg_disabled_bold = '#41444B'; // A more prominent version of Disabled and is typically used for smaller UI components such as Switch.
export const color_bg_selected = '#635DFF'; // Use for selected states that don’t span a large surface.
export const color_bg_selected_hover = '#564ED1'; // Hover state for Selected.
export const color_bg_selected_pressed = '#493FA3'; // Pressed state for Selected.
export const color_bg_selected_subtle = '#E9E8FF'; // A less prominent version of Selected and can be used for selected backgrounds that span a larger surface, or to complement a Selected border in smaller components.
export const color_bg_selected_subtle_hover = '#BCBAFF'; // Hover state for Selected Subtle.
export const color_bg_selected_subtle_pressed = '#908BFF'; // Pressed state for Selected Subtle.
export const color_bg_state_neutral = '#65676E'; // Default neutral state background color. Typically used as an accent color and can complement State Neutral Subtle in alerts.
export const color_bg_state_info = '#1071F2'; // Default info background color. Typically used as an accent color and can complement State Info Subtle in alerts.
export const color_bg_state_success = '#066B61'; // Default success background color. Typically used as an accent color and can complement State Success Subtle in alerts.
export const color_bg_state_caution = '#EBCA40'; // Default caution or warning background color. Typically used as an accent color and can complement State Caution Subtle in alerts.
export const color_bg_state_danger = '#D03C38'; // Default danger or error background color. Typically used as an accent color and can complement State Danger Subtle in alerts.
export const color_bg_state_neutral_subtle = '#EFF0F2'; // A less prominent version of State Neutral and can be used in layers that span a larger surface.
export const color_bg_state_info_subtle = '#DDEBFD'; // A less prominent version of State Info and can be used in layers that span a larger surface.
export const color_bg_state_success_subtle = '#DEF7F1'; // A less prominent version of State Success and can be used in layers that span a larger surface.
export const color_bg_state_caution_subtle = '#FCF7E4'; // A less prominent version of State Caution and can be used in layers that span a larger surface.
export const color_bg_state_danger_subtle = '#FFEEED'; // A less prominent version of State Danger and can be used in layers that span a larger surface.
export const color_bg_button = '#FFFFFF'; // Default Button background color.
export const color_bg_button_hover = '#EFF0F2'; // Hover state for Button.
export const color_bg_button_pressed = '#E3E4E6'; // Pressed state for Button.
export const color_bg_button_primary = '#635DFF'; // Default Primary Button background color.
export const color_bg_button_primary_hover = '#564ED1'; // Hover state for Button Primary.
export const color_bg_button_primary_pressed = '#493FA3'; // Pressed state for Button Primary.
export const color_bg_button_danger = '#D03C38'; // Default Danger Button background color.
export const color_bg_button_danger_hover = '#AA2D31'; // Hover state for Button Danger.
export const color_bg_button_danger_pressed = '#841E2A'; // Pressed state for Button Danger.
export const color_bg_button_inverse_static = '#FFFFFF'; // Use on high contrast backgrounds or images.
export const color_bg_button_inverse_static_hover = '#FFFFFF'; // Hover state for Button Inverse Static.
export const color_bg_button_inverse_static_pressed = '#FFFFFF'; // Pressed state for Button Inverse.
export const color_bg_button_disabled = '#E3E4E6'; // Default Disabled Button background color.
export const color_bg_link_hover = 'rgba(65, 68, 75, 0.15)'; // Hover state for default links.
export const color_bg_link_pressed = '#E3E4E6'; // Pressed state for default links.
export const color_bg_link_primary_hover = '#E9E8FF'; // Hover state for primary links.
export const color_bg_link_primary_pressed = '#BCBAFF'; // Pressed state for primary links.
export const color_bg_link_danger_hover = '#FFEEED'; // Hover state for danger links.
export const color_bg_link_danger_pressed = '#FFABA4'; // Pressed state for danger links.
export const color_bg_link_inverse_static_hover = 'rgba(255, 255, 255, 0.15)'; // Hover state for inverse links that are used on high contrast backgrounds or images.
export const color_bg_link_inverse_static_pressed = 'rgba(255, 255, 255, 0.25)'; // Pressed state for inverse links that are used on high contrast backgrounds or images.
export const color_bg_input = '#FFFFFF'; // Use for input components or form elements.
export const color_bg_input_disabled = '#EFF0F2'; // Use for disabled input components or form elements.
export const color_bg_input_disabled_bold = '#96989D'; // Use for disabled input components or form elements that are smaller in size and require higher contrast to improve their legibility.
export const color_bg_app_bar = '#1E212A'; // Default background for the App Bar component.
export const color_bg_switch_on = '#13A688'; // Use for the on state in the Switch component.
export const color_bg_switch_on_disabled = '#88E3CD'; // Use for the disabled on state in the Switch component.
export const color_bg_brand_primary = '#635DFF'; // Use to highlight branded content on a page, or for labels, badges, and avatars.
export const color_bg_brand_primary_subtle = '#E9E8FF'; // A less prominent version of Brand Primary Subtle.
export const color_fg_default = '#65676E'; // Use for body content, such as paragraphs or data display.
export const color_fg_bold = '#1E212A'; // Use for headings or prominent body content.
export const color_fg_disabled = '#65676E'; // Use for disabled text.
export const color_fg_decorative = '#41444B'; // Use for decorative elements only as it doesn't provide enough contrast against most backgrounds.
export const color_fg_selected = '#635DFF'; // Use for selected text.
export const color_fg_inverse = '#FFFFFF'; // Use on high contrast backgrounds or images.
export const color_fg_inverse_subtle = 'rgba(255, 255, 255, 0.75)'; // A less prominent version of Inverse.
export const color_fg_inverse_disabled = 'rgba(255, 255, 255, 0.5)'; // A disabled version of Inverse.
export const color_fg_inverse_static = '#FFFFFF'; // Use on high contrast backgrounds that remain the same across all themes.
export const color_fg_inverse_static_subtle = 'rgba(255, 255, 255, 0.75)'; // A less prominent version of Inverse Static.
export const color_fg_inverse_static_disabled = 'rgba(255, 255, 255, 0.5)'; // A disabled version of Inverse Static.
export const color_fg_link_primary = '#635DFF'; // Use to highlight links within paragraphs or actions that require a high level of prominence on a page.
export const color_fg_link_primary_hover = '#493FA3'; // Hover state for Link Primary.
export const color_fg_link_primary_pressed = '#3C3075'; // Pressed state for Link Primary.
export const color_fg_link = '#1E212A'; // Default link color for actions that are clearly defined on a page and don’t require a high level of prominence.
export const color_fg_link_hover = '#1E212A'; // Hover state for Link.
export const color_fg_link_pressed = '#1E212A'; // Pressed state for Link.
export const color_fg_link_subtle = '#65676E'; // A less prominent version of Link for less prominent actions on a page.
export const color_fg_link_subtle_hover = '#41444B'; // Hover state for Link Subtle.
export const color_fg_link_subtle_pressed = '#1E212A'; // Pressed state for Link Subtle.
export const color_fg_link_danger = '#D03C38'; // Use for destructive actions or links such as delete.
export const color_fg_link_danger_hover = '#AA2D31'; // Hover state for Link Danger.
export const color_fg_link_danger_pressed = '#5F0F24'; // Pressed state for Link Danger.
export const color_fg_input_placeholder = '#65676E'; // Default color for input placeholder text.
export const color_fg_state_neutral = '#1E212A'; // Use for neutral state text.
export const color_fg_state_info = '#1071F2'; // Use for info text.
export const color_fg_state_success = '#0D8975'; // Use for success text.
export const color_fg_state_caution = '#85611B'; // Use for caution or warning text.
export const color_fg_state_danger = '#D03C38'; // Use for danger or error text.
export const color_fg_on_state_neutral = '#FFFFFF'; // Use for text that goes on State Neutral backgrounds.
export const color_fg_on_state_neutral_subtle = '#1E212A'; // Use for text that goes on State Neutral Subtle backgrounds.
export const color_fg_on_state_info = '#FFFFFF'; // Use for text that goes on State Info backgrounds.
export const color_fg_on_state_info_subtle = '#00407D'; // Use for text that goes on State Info Subtle backgrounds.
export const color_fg_on_state_success = '#FFFFFF'; // Use for text that goes on State Success backgrounds.
export const color_fg_on_state_success_subtle = '#004E4E'; // Use for text that goes on State Success Subtle backgrounds.
export const color_fg_on_state_caution = '#000000'; // Use for text that goes on State Caution backgrounds.
export const color_fg_on_state_caution_subtle = '#522C09'; // Use for text that goes on State Caution Subtle backgrounds.
export const color_fg_on_state_danger = '#FFFFFF'; // Use for text that goes on State Danger backgrounds.
export const color_fg_on_state_danger_subtle = '#5F0F24'; // Use for text that goes on State Danger Subtle backgrounds.
export const color_fg_on_button = '#1E212A'; // Use for text that goes on Button background.
export const color_fg_on_button_inverse_static_static = '#FFFFFF'; // Use for text that goes on Button Inverse Static background.
export const color_fg_on_button_disabled = '#65676E'; // Use for text that goes on Button Disabled backgrounds.
export const color_fg_identicon = '#65676E'; // Default color for an identicon.
export const color_fg_identicon_subtle = '#9B9D9F'; // A lighter accent for an identicon.
export const color_fg_identicon_subtlest = '#C4C4C4'; // The lightest accent for an identicon.
export const color_fg_identicon_highlight = '#635DFF'; // Default highlight color for an identicon.
export const color_fg_identicon_highlight_subtle = '#A5A0FF'; // A lighter highlight accent for an identicon.
export const color_fg_identicon_highlight_subtlest = '#D0CEFF'; // The lightest highlight accent for an identicon.
export const color_fg_brand_primary = '#635DFF'; // Use to highlight branded content on a page, or for labels, badges, and avatars.
export const color_fg_on_brand_primary_subtle = '#3C3075'; // Use for text that goes on Brand Primary Subtle backgrounds.
export const color_fg_on_brand_primary = '#FFFFFF'; // Use for text that goes on Brand Primary backgrounds.
export const color_fg_on_button_primary = '#FFFFFF'; // Use for text that goes on Button Primary background.
export const color_fg_on_button_danger = '#FFFFFF'; // Use for text that goes on Button Danger background.
export const color_fg_selected_disabled = '#635DFF'; // Use for selected disabled text.
export const color_fg_on_button_inverse_static = '#000000'; // Use for text that goes on Button Inverse Static background.
export const color_fg_brand_primary_subtle = '#BCBAFF'; // Use to highlight branded content on a page subtly where legibility isn’t a requirement.
export const color_elevation_default = 'rgba(0, 0, 0, 0.1)'; // Default shadow color for elevations.
export const color_elevation_bold = 'rgba(0, 0, 0, 0.18)'; // A more prominent version of Default.
export const color_chart_categorical_1 = '#635DFF'; // Use for data visualization. Step 1 of 6.
export const color_chart_categorical_2 = '#FF44DD'; // Use for data visualization. Step 2 of 6.
export const color_chart_categorical_3 = '#13A688'; // Use for data visualization. Step 3 of 6.
export const color_chart_categorical_4 = '#EBCA40'; // Use for data visualization. Step 4 of 6.
export const color_chart_categorical_5 = '#D03C38'; // Use for data visualization. Step 5 of 6.
export const color_chart_categorical_6 = '#96989D'; // Use for data visualization. Step 6 of 6.
export const color_chart_sequential_1 = '#635DFF'; // An alternate option for data visualization. Step 1 of 4.
export const color_chart_sequential_2 = '#BCBAFF'; // An alternate option for data visualization. Step 2 of 4.
export const color_chart_sequential_3 = '#3C3075'; // An alternate option for data visualization. Step 3 of 4.
export const color_chart_sequential_4 = '#908BFF'; // An alternate option for data visualization. Step 4 of 4.
export const size_layout_app_top = 0; // Pixel value of the top of the app. This is normally 0.
export const size_layout_app_bar_height = 56; // Pixel value of the top of the app. This is normally 0.
export const size_layout_sidebar_width = 265; // Pixel value of the width of the sidebar when open
export const size_layout_sidebar_width_collapsed = 68; // Pixel value of the width of the sidebar when collapsed
export const type_global_monospace_10 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.6875rem',
  lineHeight: '1.45455',
  letterSpacing: '0.02em',
};
export const type_global_monospace_25 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.75rem',
  lineHeight: '1.33333',
  letterSpacing: '0.02em',
};
export const type_global_monospace_50 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0.02em',
};
export const type_global_monospace_75 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.875rem',
  lineHeight: '1.42857',
  letterSpacing: '0.02em',
};
export const type_global_monospace_100 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
};
export const type_global_monospace_200 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0.02em',
};
export const type_global_monospace_300 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0.02em',
};
export const type_global_monospace_400 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0.02em',
};
export const type_global_monospace_500 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1.75rem',
  lineHeight: '1.28571',
  letterSpacing: '0.02em',
};
export const type_global_monospace_600 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '2rem',
  lineHeight: '1.25',
  letterSpacing: '0.02em',
};
export const type_global_monospace_700 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '2.5rem',
  lineHeight: '1.2',
  letterSpacing: '0.02em',
};
export const type_global_monospace_800 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '3rem',
  lineHeight: '1.16667',
  letterSpacing: '0.02em',
};
export const type_global_monospace_900 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '3.5rem',
  lineHeight: '1.21429',
  letterSpacing: '0.02em',
};
export const type_global_monospace_1000 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '4rem',
  lineHeight: '1.1875',
  letterSpacing: '0.02em',
};
export const type_global_monospace_2000 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '4.5rem',
  lineHeight: '1.22222',
  letterSpacing: '0.02em',
};
export const type_global_monospace_3000 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '5rem',
  lineHeight: '1.2',
  letterSpacing: '0.02em',
};
export const type_global_monospace_4000 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '5.5rem',
  lineHeight: '1.18182',
  letterSpacing: '0.02em',
};
export const type_global_monospace_25_alt = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
};
export const type_global_monospace_75_alt = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0.02em',
};
export const type_global_secondary_10 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.6875rem',
  lineHeight: '1.45455',
  letterSpacing: '0em',
};
export const type_global_secondary_25 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.33333',
  letterSpacing: '0em',
};
export const type_global_secondary_50 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0em',
};
export const type_global_secondary_75 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.42857',
  letterSpacing: '0em',
};
export const type_global_secondary_100 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
};
export const type_global_secondary_200 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0em',
};
export const type_global_secondary_300 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
};
export const type_global_secondary_400 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0em',
};
export const type_global_secondary_500 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.75rem',
  lineHeight: '1.28571',
  letterSpacing: '0em',
};
export const type_global_secondary_600 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2rem',
  lineHeight: '1.25',
  letterSpacing: '0em',
};
export const type_global_secondary_700 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2.5rem',
  lineHeight: '1.2',
  letterSpacing: '0em',
};
export const type_global_secondary_800 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3rem',
  lineHeight: '1.16667',
  letterSpacing: '0em',
};
export const type_global_secondary_900 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3.5rem',
  lineHeight: '1.21429',
  letterSpacing: '0em',
};
export const type_global_secondary_1000 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4rem',
  lineHeight: '1.1875',
  letterSpacing: '0em',
};
export const type_global_secondary_2000 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4.5rem',
  lineHeight: '1.22222',
  letterSpacing: '0em',
};
export const type_global_secondary_3000 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5rem',
  lineHeight: '1.2',
  letterSpacing: '0em',
};
export const type_global_secondary_4000 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5.5rem',
  lineHeight: '1.18182',
  letterSpacing: '0em',
};
export const type_global_secondary_25_alt = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
};
export const type_global_secondary_75_alt = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
};
export const type_global_primary_10 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.6875rem',
  lineHeight: '1.45455',
  letterSpacing: '0em',
};
export const type_global_primary_25 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.33333',
  letterSpacing: '0em',
};
export const type_global_primary_50 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0em',
};
export const type_global_primary_75 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.42857',
  letterSpacing: '0em',
};
export const type_global_primary_100 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
};
export const type_global_primary_200 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0em',
};
export const type_global_primary_300 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
};
export const type_global_primary_400 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0em',
};
export const type_global_primary_500 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.75rem',
  lineHeight: '1.28571',
  letterSpacing: '0em',
};
export const type_global_primary_600 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2rem',
  lineHeight: '1.25',
  letterSpacing: '0em',
};
export const type_global_primary_700 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2.5rem',
  lineHeight: '1.2',
  letterSpacing: '0em',
};
export const type_global_primary_800 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3rem',
  lineHeight: '1.16667',
  letterSpacing: '0em',
};
export const type_global_primary_900 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3.5rem',
  lineHeight: '1.21429',
  letterSpacing: '0em',
};
export const type_global_primary_1000 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4rem',
  lineHeight: '1.1875',
  letterSpacing: '0em',
};
export const type_global_primary_2000 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4.5rem',
  lineHeight: '1.22222',
  letterSpacing: '0em',
};
export const type_global_primary_3000 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5rem',
  lineHeight: '1.2',
  letterSpacing: '0em',
};
export const type_global_primary_4000 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5.5rem',
  lineHeight: '1.18182',
  letterSpacing: '0em',
};
export const type_global_primary_25_alt = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
};
export const type_global_primary_75_alt = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
};
export const type_code_50 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  fontWeight: '400',
}; // Smallest size for code blocks or editors.
export const type_code_100 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0.02em',
  fontWeight: '400',
}; // Default size for code blocks or editors.
export const type_code_200 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  fontWeight: '400',
}; // Large size for code blocks or editors.
export const type_code_300 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0.02em',
  fontWeight: '400',
}; // Largest size for code blocks or editors.
export const type_heading_100 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Description
export const type_heading_200 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Description
export const type_heading_300 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2rem',
  lineHeight: '1.25',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Description
export const type_heading_400 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2.5rem',
  lineHeight: '1.2',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Description
export const type_heading_500 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3rem',
  lineHeight: '1.16667',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Description
export const type_heading_600 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3.5rem',
  lineHeight: '1.21429',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Description
export const type_heading_700 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4rem',
  lineHeight: '1.1875',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Description
export const type_heading_800 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4.5rem',
  lineHeight: '1.22222',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Description
export const type_heading_900 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5rem',
  lineHeight: '1.2',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Description
export const type_heading_1000 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5.5rem',
  lineHeight: '1.18182',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Description
export const type_body_50 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Use for condensed paragraphs, labels, and data display.
export const type_body_100 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Default size for paragraphs, labels, and data display.
export const type_body_200 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Added prominence for paragraphs, labels, and data display.
export const type_body_300 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Highest prominence for paragraphs, labels, and data display.
export const type_body_400 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Default size for opening paragraphs in blogs or documentation type of applications.
export const type_body_500 = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0em',
  fontWeight: '400',
}; // A more prominent version for opening paragraphs or quotes in blogs or documentation type of applications.
export const type_body_50_emphasis = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information.
export const type_body_50_emphasis_paragraph = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '600',
}; // Use within paragraphs for bold text.
export const type_body_100_emphasis = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information.
export const type_body_100_emphasis_paragraph = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '600',
}; // Use within paragraphs for bold text.
export const type_body_200_emphasis = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information.
export const type_body_200_emphasis_paragraph = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '600',
}; // Use within paragraphs for bold text.
export const type_body_300_emphasis = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information.
export const type_body_300_emphasis_paragraph = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0em',
  fontWeight: '600',
}; // Use within paragraphs for bold text.
export const type_body_400_emphasis = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information.
export const type_body_400_emphasis_paragraph = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
  fontWeight: '600',
}; // Use within paragraphs for bold text.
export const type_body_500_emphasis = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use within paragraphs for bold text.
export const type_preset_page_title = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2rem',
  lineHeight: '1.25',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Default text style for page titles.
export const type_preset_page_title_compact = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Default text style for page titles in compact page headers.
export const type_preset_section_title = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Default text style for section titles.
export const type_preset_section_subtitle = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Default text style for section subtitles.
export const type_preset_button = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Default text style for buttons and their link variants.
export const type_preset_form_label = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Default text style for form labels.
export const type_preset_form_text = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Default text style for forms like input fields and select fields.
export const type_preset_caption = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Use for smaller captions or labels within components.
export const type_preset_caption_emphasis = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information within captions.
export const type_preset_menu_item = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Use for links or menu items.
export const type_preset_overline = {
  fontFamily:
    'Inter var, Inter,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.6875rem',
  lineHeight: '1.45455',
  letterSpacing: '0.07em',
  fontWeight: '600',
  textTransform: 'uppercase',
}; // Use for annotations, labels, and statuses.
